import * as R from 'ramda';

export const mergeSpec = R.curry((spec, value) =>
  R.converge(R.merge, [R.identity, R.applySpec(spec)])(value),
);
export const invoke = (name) => R.invoker(0, name);
